import { AxiosAdapter, CommunityAdapter } from '@adapters';
import { FetchNewMainBannersPayload, FetchNewMainBoardsPayload } from '@dto';

export const useNewMainBoards = () => {
  const axiosAdapter = new AxiosAdapter();
  const communityAdapter = new CommunityAdapter(axiosAdapter);

  const handleFetchNewMainBoards = async (
    payload: FetchNewMainBoardsPayload
  ) => {
    return await communityAdapter.fetchMainBoards(payload);
  };

  const handleFetchNewMainBanners = async (
    payload: FetchNewMainBannersPayload
  ) => {
    return await communityAdapter.fetchMainBanners(payload);
  };

  return {
    handleFetchNewMainBoards,
    handleFetchNewMainBanners,
  };
};
